import React, { useEffect, useRef } from "react";
import logo from "./img/enjuggernaut_plus_logo.png";
import SidebarElement from "./Account/SidebarElement";

import document from "./img/document.svg";
import analytics from "./img/analytics.svg";
import tailor from "./img/tailor.svg";
import account from "./img/account.svg";
import mail from "./img/mail_logo.svg";
import logout from "./img/logout.svg";

import { useAuthToken } from "./AuthProvider";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { Subscription } from "./Subscription";
import { toast } from "react-toastify";

interface MenuBarProps {
  centered: boolean;
  minimized: boolean;
}

export const MenuBar: React.FC<MenuBarProps> = ({ centered, minimized }) => {
  const {
    updateToken,
    token,
    isMember,
    isConfirmed,
    isLoading,
    isAuthenticated,
  } = useAuthToken();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [resumeCredits, setResumeCredits] = React.useState(0);
  const [isSubscriptionOverlayOpen, setIsSubscriptionOverlayOpen] =
    React.useState(false);

  const updateRedirectUri = (uri: string) => {
    dispatch({
      type: "UPDATE_URI",
      payload: uri,
    });
  };

  const maillink = "mailto:support@enjuggernaut.com";

  async function getAccountInfo() {
    if (isLoading) {
      return;
    }

    const apiEndpoint =  "/api/accountinfo";

    let headers = {};

    if (!isAuthenticated) {
      setResumeCredits(1);
    } else {
      headers = {
        Authorization: `Bearer ${token}`,
      };

      try {
        // Make a POST request using fetch
        const response = await fetch(apiEndpoint, {
          method: "GET",
          headers: headers,
        });

        if (response.ok) {
          const responseData = await response.json();
          setResumeCredits(responseData.resume_credits);
        }
      } catch (error) {
        console.error("Error:", error);
        toast.error("An error occured.");
      }
    }
  }

  React.useEffect(() => {
    if (!isLoading && isAuthenticated) {
      getAccountInfo();
    }
  }, [isLoading, isAuthenticated]);

  return (
    <div className="w-full">
      {isSubscriptionOverlayOpen && (
        <div className="overlay z-10">
          <Subscription open_fn={setIsSubscriptionOverlayOpen} />
        </div>
      )}

      <SidebarElement
        disabled={false}
        text="RESUMES"
        img={document}
        redirect={() => navigate("/resumes")}
        centered={centered}
        minimized={minimized}
      />
      <SidebarElement
        disabled={false}
        text="JOBS"
        img={tailor}
        redirect={() => navigate("/jobs")}
        centered={centered}
        minimized={minimized}
      />
      <SidebarElement
        disabled={false}
        text="ACCOUNT"
        img={account}
        redirect={() => navigate("/account")}
        centered={centered}
        minimized={minimized}
      />
      <a href={maillink}>
        <SidebarElement
          disabled={false}
          text="CONTACT"
          img={mail}
          redirect={() => {
            const x = 1 + 1;
          }}
          centered={centered}
          minimized={minimized}
        />
      </a>
      <SidebarElement
        disabled={false}
        text="LOGOUT"
        img={logout}
        redirect={() => {
          updateToken("");
          updateRedirectUri("");
          navigate("/");
        }}
        centered={centered}
        minimized={minimized}
      />

      <div className={`w-full ${minimized ? "hidden" : "block"}`}>
        <button
          className="login-button mx-auto mt-4 block w-2/3 px-6 py-2 font-code text-lg font-bold md:py-2 xl:text-xl"
          onClick={() => {
            if(isLoading) {
              return;
            } 

            if(!isAuthenticated) {
              toast.error("Please confirm your account (check your email).");
              return;
            }

            if (resumeCredits > 0) {
              navigate("/start");
            } else {
              toast.error(
                "Insufficient resume credits (consider enjuggernaut+)."
              );
            }
          }}
        >
          New Resume
        </button>

        {!isMember && (
          <div className="mt-4 flex flex-col">
            <button
              className="start-button mx-auto mt-2 block w-2/3 px-6 py-2 font-code text-lg font-bold md:py-2 xl:text-xl"
              onClick={() => {
                if (isConfirmed) {
                  setIsSubscriptionOverlayOpen(true);
                } else {
                  toast.error("Please confirm your account first.");
                }
              }}
            >
              Get Plus
            </button>
          </div>
        )}
      </div>
    </div>
  );
};
